"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageComponent = void 0;
var tslib_1 = require("tslib");
var Portal = require("react-portal-minimal");
var React = require("react");
var answers_ui_libby_1 = require("@wix/answers-ui-libby");
var answers_lib_1 = require("@wix/answers-lib");
var ImageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ImageComponent, _super);
    function ImageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            expandImage: false,
            hideFromDOM: true
        };
        _this.imgId = answers_lib_1.uuid();
        _this.accessibilityCloseExpandedImage = function (e) {
            var _a;
            var isCorrectImg = ((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.getAttribute('id')) === _this.imgId;
            if (e.keyCode === answers_ui_libby_1.KeyCode.ESCAPE || e.keyCode === answers_ui_libby_1.KeyCode.ENTER) {
                if (document.querySelector('.expanded') && isCorrectImg) {
                    _this.setState({ expandImage: false }, _this.hideWithTimeout);
                }
                if (_this.imgRef && isCorrectImg) {
                    _this.imgRef.focus();
                }
            }
        };
        _this.accessibilityExpandImage = function (e) {
            if (e.keyCode === answers_ui_libby_1.KeyCode.ENTER && !_this.state.expandImage) {
                _this.onImgClick();
                setTimeout(function () {
                    var ImgElement = document.querySelector('.expanded-img');
                    if (document.querySelector('.image-fullscreen-container.expanded') && ImgElement) {
                        ImgElement.focus();
                    }
                }, 200);
            }
        };
        _this.onImgAccessibilityClick = function () {
            if (document.activeElement && document.activeElement.blur) {
                document.activeElement.blur();
            }
        };
        _this.onExpandedAccessibilityKeyup = function (e) {
            if (e.keyCode === answers_ui_libby_1.KeyCode.ENTER) {
                _this.setState({ expandImage: false }, _this.hideWithTimeout);
                var ImgElement = document.querySelector('img.clickable');
                if (ImgElement) {
                    ImgElement.focus();
                }
            }
        };
        _this.setImgRef = function (elem) {
            if (elem) {
                _this.imgRef = elem;
                elem.addEventListener('keyup', _this.accessibilityExpandImage);
                elem.addEventListener('click', _this.onImgAccessibilityClick);
            }
        };
        _this.onImgClick = function () {
            var showWithTimeout = function () { return setTimeout(function () { return _this.setState({ expandImage: true }); }, 100); };
            var props = _this.props;
            if (!props.value.link) {
                if (!!props.onImgClick) {
                    props.onImgClick(props.value.src);
                }
                else {
                    _this.setState({ hideFromDOM: false }, showWithTimeout);
                }
            }
        };
        _this.setExpandImgRef = function (elem) {
            if (elem) {
                _this.expandedRef = elem;
                elem.addEventListener('keyup', _this.onExpandedAccessibilityKeyup);
            }
        };
        _this.hideWithTimeout = function () { return setTimeout(function () { return _this.setState({ hideFromDOM: true }); }, 100); };
        return _this;
    }
    ImageComponent.prototype.componentWillUnmount = function () {
        window.removeEventListener('keyup', this.accessibilityCloseExpandedImage);
        if (this.imgRef) {
            this.imgRef.removeEventListener('keyup', this.accessibilityExpandImage);
            this.imgRef.removeEventListener('click', this.onImgAccessibilityClick);
        }
        if (this.expandedRef) {
            this.expandedRef.removeEventListener('keyup', this.onExpandedAccessibilityKeyup);
        }
    };
    ImageComponent.prototype.componentDidMount = function () {
        window.addEventListener('keyup', this.accessibilityCloseExpandedImage);
    };
    ImageComponent.prototype.maybeLinkedImage = function () {
        var props = this.props;
        var value = this.props.value;
        var cn = answers_lib_1.classNames({ clickable: !props.value.link });
        var renderedImage = (React.createElement("img", { tabIndex: 0, id: this.imgId, ref: this.setImgRef, className: cn, src: value.src, alt: value.alt || '', onClick: this.onImgClick }));
        var linkedImage = React.createElement("a", { href: props.value.link, target: '_blank' }, renderedImage);
        return props.value.link ? linkedImage : renderedImage;
    };
    ImageComponent.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var onDismiss = function () {
            _this.setState({ expandImage: false }, _this.hideWithTimeout);
        };
        var isExpanded = this.state.expandImage ? 'expanded' : '';
        var hideFromDOM = this.state.hideFromDOM ? 'hide' : '';
        var imgFullScreenComp = !props.value.link ? (React.createElement(Portal, { className: "image-fullscreen-container " + isExpanded },
            React.createElement("div", { tabIndex: -1, id: this.imgId, ref: this.setExpandImgRef, className: "overlay " + hideFromDOM + " expanded-img", onClick: onDismiss },
                React.createElement("img", { src: props.value.src, alt: props.value.alt || '' })))) : null;
        return (React.createElement("div", { className: 'component image-component', "data-component-type": 'image' },
            React.createElement("div", { className: 'image-container' }, this.maybeLinkedImage()),
            imgFullScreenComp));
    };
    return ImageComponent;
}(React.PureComponent));
exports.ImageComponent = ImageComponent;
//# sourceMappingURL=image-component.comp.js.map